module.exports = __webpack_public_path__ + "assets/img/btn-detail-34fcd983.png";